import './styles.css';

/** Pure UI: Settings → HUD (placeholder). */
export function HudTabInterface() {
  return <p className="settings-empty">HUD options coming soon.</p>;
}
